





















































import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import List from "@/components/basic/List.vue";
import { ITicket, ITicketListRequest } from "@/types/ticket";
import { IPagination } from "@/types";
import { TicketListRequest } from "@/models/ticket";

@Component({
  components: {},
})
export default class extends List {
  @Action("ticket/salesGetList")
  public getTicketList!: (params: ITicketListRequest) => Promise<boolean>;

  @Getter("ticket/list")
  public ticketList!: ITicket[];

  @Getter("ticket/pagination")
  public pagination!: IPagination<ITicket>;

  @Mutation("ticket/clear")
  public clear!: () => void;

  @Prop()
  public query!: string;

  @Prop()
  public status!: number | string;

  @Prop()
  public charge_id!: number;

  @Watch("status")
  public async statusChanged() {
    await this.getList();
  }

  @Watch("charge_id")
  public async chargeIdChanged() {
    await this.getList();
  }

  public params: ITicketListRequest = new TicketListRequest();

  public headers = [
    {
      text: "title",
      align: "start",
      value: "subject",
    },
    { text: "担当", value: "charge.name", sortable: false },
    { text: "対象", value: "members", sortable: false },
    { text: "状態", value: "status_id" },
    { text: "期限", value: "deadline_at" },
    { text: "タグ", value: "tags", sortable: false },
  ];

  public member_id = 0;

  private async created() {
    if (this.$route.params.member_id) {
      this.member_id = Number(this.$route.params.member_id);
      this.setMemberId(this.member_id);
    }
  }

  public async getList(): Promise<void> {
    this.setStatus(this.status);
    this.setChargeId(this.charge_id);
    this.setQuery(this.query);
    await this.getTicketList(this.params);
    this.paramsToQuery();
  }

  public setStatus(status: number | string) {
    if (status === "inprogress") {
      this.params.inprogress = true;
      this.params.status = 0;
    } else if (typeof status === "number") {
      this.params.inprogress = false;
      this.params.status = status;
    }
  }

  public setChargeId(charge_id: number) {
    this.params.charge_id = charge_id;
  }

  public setQuery(query: string) {
    this.params.query = query;
  }

  public setMemberId(member_id: number) {
    this.params.member_id = member_id;
  }

  public rowClick(ticket: ITicket): void {
    if (this.member_id) {
      this.$router.push({
        name: "SalesMemberTicketDetail",
        params: {
          member_id: this.member_id.toString(),
          ticket_id: ticket.id.toString(),
        },
      });
    } else {
      this.$router.push({
        name: "SalesTicketDetail",
        params: { ticket_id: ticket.id.toString() },
      });
    }
  }
}
